import React from 'react';
export default function ComponentLibraryContentsItem({ component }) {
    return (
        <li><a href={`/component-library/${component}`}>{ component }</a></li>
    )
}